/**
 * Copyright 2025 Beijing Volcano Engine Technology Co., Ltd. All Rights Reserved.
 * SPDX-license-identifier: BSD-3-Clause
 */

import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useVisionMode } from '@/lib/useCommon';
import { RootState } from '@/store';
import RtcClient from '@/lib/RtcClient';
import Operation from './components/Operation';
import CameraArea from '../MainArea/Room/CameraArea';
import { setHistoryMsg, setInterruptMsg } from '@/store/slices/room';
import utils from '@/utils/utils';
import styles from './index.module.less';

function Menu() {
  const dispatch = useDispatch();
  const [question, setQuestion] = useState('');
  const room = useSelector((state: RootState) => state.room);
  const isJoined = room?.isJoined;
  const isVisionMode = useVisionMode();

  useEffect(() => {
    if (question && !room.isAITalking) {
      dispatch(setInterruptMsg());
      dispatch(
        setHistoryMsg({
          text: question,
          user: RtcClient.basicInfo.user_id,
          paragraph: true,
          definite: true,
        })
      );
      setQuestion('');
    }
  }, [question, room.isAITalking]);

  return (
    <div className={styles.wrapper}>
      {/* {isJoined && utils.isMobile() && isVisionMode ? (
        <div className={styles['mobile-camera-wrapper']}>
          <CameraArea className={styles['mobile-camera']} />
        </div>
      ) : null} */}
      {isJoined ? <Operation /> : ''}
    </div>
  );
}

export default Menu;
